Ext.define('SA.view.Table', {
    alias: 'widget.table',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-table',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-table-part-container',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-table-corner',
                    itemId: 'corner'
                }, {
                    xtype: 'table-section',
                    cls: 'sa-table-top-header-section',
                    itemId: 'topHeader'
                }, {
                    xtype: 'component',
                    cls: 'sa-table-vertical-scrollbar-cap',
                    itemId: 'verticalScrollbarCap'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-table-part-container',

            items: [
                {
                    xtype: 'table-section',
                    cls: 'sa-table-left-header-section',
                    itemId: 'leftHeader'
                }, {
                    xtype: 'component',
                    cls: 'sa-table-horizontal-scrollbar-cap',
                    itemId: 'horizontalScrollbarCap'
                }, {
                    xtype: 'table-section',
                    cls: 'sa-table-body-section',
                    itemId: 'body'
                }
            ]
        }
    ]
});